module.exports = __webpack_public_path__ + "assets/img/3bf260a3cfa9dd3702cbdaabe29344f5.svg";